import camelCase from "lodash-es/camelCase";
import React, { PureComponent, ReactNode } from "react";

import { footerInteractionTracking } from "../../../../../../../services/analytics.service";
import { translate } from "../../../../../../../services/translation.service";
import Hyperlink from "../../../../../../Hyperlink";
import SectionFooter from "../SectionFooter";

import { PaymentIcons } from "./components";

export default class PaymentSection extends PureComponent {
  public render(): ReactNode {
    return (
      <SectionFooter title={translate("footer.securePayment")}>
        <Hyperlink
          to={translate("links.securePayment")}
          onClick={(): void =>
            footerInteractionTracking(
              camelCase(translate("footer.securePayment"))
            )
          }
        >
          <PaymentIcons />
        </Hyperlink>
      </SectionFooter>
    );
  }
}
